import React from "react";
import { PiSquaresFourLight } from "react-icons/pi";
import { CgFeed, CgProfile } from "react-icons/cg";
import { useAuth } from "../../Providers/Auth";
import { useLocation, useNavigate } from "react-router-dom";

import { useGeneralSettings } from "../../Providers/General";
import { GiTwoCoins } from "react-icons/gi";
// import { toast } from "react-toastify"
import { IoDiamondOutline } from "react-icons/io5";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/shadcnComponents/ui/dropdown-menu";

import { IoFlashOutline } from "react-icons/io5";
import mixpanel from "mixpanel-browser";

const MobileMenuBar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const authState = useAuth();
  const generalState = useGeneralSettings();

  return (
    <div className="flex md:hidden w-screen z-50  items-start  shadow-[0px_-4px_4px_0px_rgba(255,255,255,0.10)] bg-[#000] fixed bottom-0 ">
      <section className="w-full flex justify-between items-start px-10 py-3">
        {/* Dashboard */}
        <span
          className={`text-xs font-medium ${
            location.pathname === "/influencer/dashboard" ||
            location.pathname === "/influencer"
              ? "text-[#DC2627]"
              : "text-[#A6A6A6] bg-transparent"
          }  hover:text-[#FAFAFA] rounded-md cursor-pointer flex flex-col justify-center items-center gap-1`}
          onClick={() => {
            mixpanel.track("Clicked on Dashboard link in Sidebar");
            navigate("/influencer/dashboard");
          }}
        >
          <span>
            <PiSquaresFourLight size={18} />
          </span>
          <span>Dashboard</span>
        </span>

        {/* Analytics */}
        {/* <span
          className={`text-xs font-medium ${
            location.pathname === "/influencer/analytics"
              ? "text-[#DC2627]"
              : "text-[#A6A6A6] bg-transparent"
          }  hover:text-[#FAFAFA] rounded-md cursor-pointer flex flex-col justify-center items-center gap-1`}
          onClick={() => {
            mixpanel.track("Clicked on Analytics link in Sidebar");
            navigate("/influencer/analytics");
          }}
        >
          <span>
            <TbDeviceAnalytics size={18} />
          </span>
          <span>Analytics</span>
        </span> */}

        {/* Feed */}
        <span
          className={`text-xs font-medium ${
            location.pathname === "/influencer/feed"
              ? "text-[#DC2627]"
              : "text-[#A6A6A6] bg-transparent"
          }  hover:text-[#FAFAFA] rounded-md cursor-pointer flex flex-col justify-center items-center gap-1`}
          onClick={() => {
            mixpanel.track("Clicked on Feed link in Sidebar");
            navigate("/influencer/feed");
          }}
        >
          <span>
            <CgFeed size={18} />
          </span>
          <span>Feed</span>
        </span>

        {/* <span
          className={`text-sm font-medium ${
            location.pathname === "/influencer/feed" ||
            location.pathname === "/influencer"
              ? "text-[#FFFFFF] bg-[#381c1c]"
              : "text-[#A6A6A6] bg-transparent"
          } md:hidden  py-[6px] px-3 hover:bg-[#381c1c] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
          onClick={() => {
            mixpanel.track("Clicked on feed link in Sidebar");
            navigate("/influencer/feed");
          }}
        >
          <BiNetworkChart size={18} /> Feed
        </span> */}

        {/* Boost Visibility */}
        {authState?.loggedUser?.slug && (
          <span
            className={`text-xs font-medium ${
              location.pathname === "/influencer/boostVisibility"
                ? "text-[#DC2627]"
                : "text-[#A6A6A6] bg-transparent"
            }  hover:text-[#FAFAFA] hidden rounded-md cursor-pointer flex-col justify-center items-center gap-1`}
            onClick={() => {
              mixpanel.track("Clicked on Boost Visibility link in Sidebar");
              navigate("/influencer/boostVisibility");
            }}
          >
            <span>
              <IoFlashOutline size={18} />
            </span>
            <span>Boost</span>
          </span>
        )}

        {/* Brand Deals */}
        <span
          className={`text-xs font-medium ${
            location.pathname === "/influencer/brandCollabs"
              ? "text-[#DC2627]"
              : "text-[#A6A6A6] bg-transparent"
          } hover:text-[#FAFAFA] rounded-md cursor-pointer flex flex-col justify-center items-center gap-1`}
          onClick={() => {
            mixpanel.track("Clicked on Brand Deals link in Sidebar");
            navigate("/influencer/brandCollabs");
          }}
        >
          <span>
            <IoDiamondOutline size={18} />
          </span>
          <span>Deals</span>
        </span>

        {/* profile */}
        <DropdownMenu>
          <DropdownMenuTrigger>
            {" "}
            <span
              className={`text-xs font-medium ${
                location.pathname === "/influencer/build_profile"
                  ? "text-[#DC2627]"
                  : "text-[#A6A6A6] bg-transparent"
              } hover:text-[#FAFAFA] rounded-md cursor-pointer flex flex-col justify-center items-center gap-1`}
              onClick={() => {
                mixpanel.track("Clicked on Profile link in Sidebar");
                navigate("/influencer/build_profile?page=profile");
              }}
            >
              <span>
                <CgProfile size={18} />
              </span>
              <span>Profile</span>
            </span>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="bg-[#1A1A1A] ">
            <DropdownMenuItem
              className={`cursor-pointer ${
                location.search === "?page=profile" &&
                location.pathname === "/influencer/build_profile"
                  ? "text-[#FFFFFF] bg-[#381c1c]"
                  : "text-[#A6A6A6] bg-transparent"
              } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm `}
              onClick={() => {
                mixpanel.track(
                  "Clicked on Personal Information link in Sidebar"
                );
                navigate("/influencer/build_profile?page=profile");
              }}
            >
              <div className="flex w-full justify-between align-center gap-[8px]">
                Personal Information
                <span className="flex text-xs items-center gap-2">
                  <GiTwoCoins color="#FFD700" />{" "}
                  {generalState.SidebarChipsCount.profile || 0}
                </span>
              </div>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`cursor-pointer ${
                location.search === "?page=content" &&
                location.pathname === "/influencer/build_profile"
                  ? "text-[#FFFFFF] bg-[#381c1c]"
                  : "text-[#A6A6A6] bg-transparent"
              } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
              onClick={() => {
                mixpanel.track("Clicked on Content Expertise link in Sidebar");
                navigate("/influencer/build_profile?page=content");
              }}
            >
              <div className="flex w-full justify-between align-center gap-[8px]">
                Content Expertise
                <span className="flex text-xs items-center gap-2">
                  <GiTwoCoins color="#FFD700" />{" "}
                  {generalState.SidebarChipsCount.content || 0}
                </span>
              </div>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`cursor-pointer ${
                location.search === "?page=audience" &&
                location.pathname === "/influencer/build_profile"
                  ? "text-[#FFFFFF] bg-[#381c1c]"
                  : "text-[#A6A6A6] bg-transparent"
              } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
              onClick={() => {
                mixpanel.track("Clicked on Audience Info link in Sidebar");
                navigate("/influencer/build_profile?page=audience");
              }}
            >
              <div className="flex w-full justify-between align-center gap-[8px]">
                Audience info
                <span className="flex text-xs items-center gap-2">
                  <GiTwoCoins color="#FFD700" />{" "}
                  {generalState.SidebarChipsCount.audience || 0}
                </span>
              </div>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`cursor-pointer ${
                location.search === "?page=collab" &&
                location.pathname === "/influencer/build_profile"
                  ? "text-[#FFFFFF] bg-[#381c1c]"
                  : "text-[#A6A6A6] bg-transparent"
              } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
              onClick={() => {
                mixpanel.track("Clicked on Collab Portfolio link in Sidebar");
                navigate("/influencer/build_profile?page=collab");
              }}
            >
              <div className="flex w-full justify-between align-center gap-[8px]">
                Collab Portfolio
                <span className="flex text-xs items-center gap-2">
                  <GiTwoCoins color="#FFD700" />{" "}
                  {generalState.SidebarChipsCount.collab || 0}
                </span>
              </div>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`cursor-pointer ${
                location.search === "?page=monetization" &&
                location.pathname === "/influencer/build_profile"
                  ? "text-[#FFFFFF] bg-[#381c1c]"
                  : "text-[#A6A6A6] bg-transparent"
              } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
              onClick={() => {
                mixpanel.track(
                  "Clicked on Monetization Expertise link in Sidebar"
                );
                navigate("/influencer/build_profile?page=monetization");
              }}
            >
              <div className="flex w-full justify-between align-center gap-[8px]">
                Monetization Expertise
                <span className="flex text-xs items-center gap-2">
                  <GiTwoCoins color="#FFD700" />{" "}
                  {generalState.SidebarChipsCount.monetization || 0}
                </span>
              </div>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`cursor-pointer ${
                location.search === "?page=pricing" &&
                location.pathname === "/influencer/build_profile"
                  ? "text-[#FFFFFF] bg-[#381c1c]"
                  : "text-[#A6A6A6] bg-transparent"
              } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
              onClick={() => {
                mixpanel.track(
                  "Clicked on Control Your Pricing link in Sidebar"
                );
                navigate("/influencer/build_profile?page=pricing");
              }}
            >
              <div className="flex w-full justify-between align-center gap-[8px]">
                Control Your Pricing
                <span className="flex text-xs items-center gap-2">
                  <GiTwoCoins color="#FFD700" />{" "}
                  {generalState.SidebarChipsCount.charges || 0}
                </span>
              </div>
            </DropdownMenuItem>
            <DropdownMenuItem
              className={`cursor-pointer ${
                location.pathname === "/influencer/payment"
                  ? "text-[#FFFFFF] bg-[#381c1c]"
                  : "text-[#A6A6A6] bg-transparent"
              } hover:text-[#FFFFFF] flex items-center justify-between w-full px-[8px] py-[6px] rounded-sm  `}
              onClick={() => {
                mixpanel.track("Clicked on Make Me Visible link in Sidebar");
                navigate("/influencer/payment");
              }}
            >
              <div className="flex w-full justify-between align-center gap-[8px]">
                Make Me Visible
              </div>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </section>
    </div>
  );
};

export default MobileMenuBar;
